export default "__VITE_ASSET__DS5MEaG8__"